// Badge ROAS com paleta Esmeralda (verde/amarelo/error semânticos).

interface Props { roas: number; reference?: number; size?: "sm" | "md" }

export default function RoasBadge({ roas, reference, size = "sm" }: Props) {
  const valid = roas > 0;
  const tone =
    !valid ? "neutral" :
    roas >= 3 ? "great" :
    roas >= 2 ? "good" :
    roas >= 1 ? "warn" : "bad";

  const styles: Record<string, string> = {
    great:   "bg-[#dcfce7] text-[#166534] border-[#bbf7d0]",
    good:    "bg-esm-cream-50 text-esm-brown-700 border-esm-brown-100",
    warn:    "bg-[#fef3c7] text-[#92400e] border-[#fde68a]",
    bad:     "bg-[#fee2e2] text-[#991b1b] border-[#fecaca]",
    neutral: "bg-esm-gray-50 text-esm-gray-400 border-esm-gray-100",
  };
  const sizeClass = size === "md" ? "text-base px-3 py-1" : "text-sm px-2 py-0.5";

  const delta = reference && reference > 0 && valid ? ((roas - reference) / reference) * 100 : null;

  return (
    <span className={`inline-flex items-baseline gap-1 rounded-md border font-bold tabular-nums ${styles[tone]} ${sizeClass}`}>
      <span>{valid ? `${roas.toFixed(2).replace(".", ",")}x` : "—"}</span>
      {delta !== null && Math.abs(delta) >= 1 && (
        <span className={`text-[10px] font-semibold ${delta > 0 ? "text-esm-success" : "text-esm-error"}`}>
          ({delta > 0 ? "↑" : "↓"}{Math.abs(delta).toFixed(1).replace(".", ",")}%)
        </span>
      )}
    </span>
  );
}
